import { render } from "./OrderStatusChange.vue?vue&type=template&id=b0db87c6&scoped=true"
import script from "./OrderStatusChange.vue?vue&type=script&lang=js"
export * from "./OrderStatusChange.vue?vue&type=script&lang=js"

import "./OrderStatusChange.vue?vue&type=style&index=0&id=b0db87c6&lang=scss&scoped=true"

import exportComponent from "/Users/ferlando/Desktop/Baboon/baboon-pos/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0db87c6"]])

export default __exports__